var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8753 8.75H12.292C11.947 8.75 11.667 8.47 11.667 8.125C11.667 7.78 11.947 7.5 12.292 7.5H16.8753C17.2203 7.5 17.5003 7.78 17.5003 8.125C17.5003 8.47 17.2203 8.75 16.8753 8.75Z",
    fill: "#778797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8753 12.0833H12.292C11.947 12.0833 11.667 11.8033 11.667 11.4583C11.667 11.1133 11.947 10.8333 12.292 10.8333H16.8753C17.2203 10.8333 17.5003 11.1133 17.5003 11.4583C17.5003 11.8033 17.2203 12.0833 16.8753 12.0833Z",
    fill: "#778797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8753 15.4167H12.292C11.947 15.4167 11.667 15.1367 11.667 14.7917C11.667 14.4467 11.947 14.1667 12.292 14.1667H16.8753C17.2203 14.1667 17.5003 14.4467 17.5003 14.7917C17.5003 15.1367 17.2203 15.4167 16.8753 15.4167Z",
    fill: "#778797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70833 10.8334H3.95833C3.15417 10.8334 2.5 10.1793 2.5 9.37509V8.12509C2.5 7.32092 3.15417 6.66675 3.95833 6.66675H7.70833C8.5125 6.66675 9.16667 7.32092 9.16667 8.12509V9.37509C9.16667 10.1793 8.5125 10.8334 7.70833 10.8334ZM3.95833 7.91675C3.84333 7.91675 3.75 8.01009 3.75 8.12509V9.37509C3.75 9.49009 3.84333 9.58342 3.95833 9.58342H7.70833C7.82333 9.58342 7.91667 9.49009 7.91667 9.37509V8.12509C7.91667 8.01009 7.82333 7.91675 7.70833 7.91675H3.95833Z",
    fill: "#778797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70833 16.6667H3.95833C3.15417 16.6667 2.5 16.0125 2.5 15.2083V13.9583C2.5 13.1542 3.15417 12.5 3.95833 12.5H7.70833C8.5125 12.5 9.16667 13.1542 9.16667 13.9583V15.2083C9.16667 16.0125 8.5125 16.6667 7.70833 16.6667ZM3.95833 13.75C3.84333 13.75 3.75 13.8433 3.75 13.9583V15.2083C3.75 15.3233 3.84333 15.4167 3.95833 15.4167H7.70833C7.82333 15.4167 7.91667 15.3233 7.91667 15.2083V13.9583C7.91667 13.8433 7.82333 13.75 7.70833 13.75H3.95833Z",
    fill: "#778797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 19.1666H2.29167C1.0275 19.1666 0 18.1391 0 16.8749V3.12492C0 1.86075 1.0275 0.833252 2.29167 0.833252H17.7083C18.9725 0.833252 20 1.86075 20 3.12492V16.8749C20 18.1391 18.9725 19.1666 17.7083 19.1666ZM2.29167 2.08325C1.7175 2.08325 1.25 2.55075 1.25 3.12492V16.8749C1.25 17.4491 1.7175 17.9166 2.29167 17.9166H17.7083C18.2825 17.9166 18.75 17.4491 18.75 16.8749V3.12492C18.75 2.55075 18.2825 2.08325 17.7083 2.08325H2.29167Z",
    fill: "#778797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 5H0.625C0.28 5 0 4.72 0 4.375C0 4.03 0.28 3.75 0.625 3.75H19.375C19.72 3.75 20 4.03 20 4.375C20 4.72 19.72 5 19.375 5Z",
    fill: "#778797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFile);
export default __webpack_public_path__ + "static/media/info_file.a5aa30369e4e844b15e6c33d6356038e.svg";
export { ForwardRef as ReactComponent };